/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { emptyValidation, customAlaphabetValidation, customAlaphabetValidationOptional } from "../../../../../helpers/validation";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg"
import { NavLink } from "react-router-dom";
import { Row, Col, Image, Space } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Button, TextField, Box } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { toast } from 'react-toastify';
import clsx from "clsx";
import usePrevious from "../../../../Shared/components/Previous";
import { ListTable } from './ListTable.js';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const Currency = (props) => {
    const { currencyDetails, loader } = useSelector(state => state.adminSetupReducer);
    const { createDetails, createError, createLoader, getList, getData } = useSelector(state => state.crudReducer);

    const [visible, setVisible] = useState(false);
    const [name, setName] = useState('');
    const [shortName, setShortName] = useState('');
    const [symbol, setSymbol] = useState('');
    const [addMore, setAddMore] = useState(false);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [errorName, setErrorName] = useState('');
    const [errorShortName, setErrorShortName] = useState('');
    const [errorSymbol, setErrorSymbol] = useState('');
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [skip, setSkip] = useState(0);
    const limit = 25;

    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const handleOpen = () => {
        setVisible(true);
        emptyState();
        emptyStateInput();
    };
    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };
    const dispatch = useDispatch();


    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(search, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(search, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Currency', history, 'Younote Admin')) {
                loadTasks();
                return () => {
                    dispatch({ type: crudActions.CLEAR_CRUD_DETAILS_START });
                }
            }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (search, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ shortName: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ symbol: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'currency',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(search, sortBy, sortOrder);
    }, [dispatch]);

    const emptyState = () => {
        setErrorName(false);
        setErrorShortName(false);
        setErrorSymbol(false);
    };

    const emptyStateInput = () => {
        setName('');
        setShortName('');
        setSymbol('');
    };

    const createCurrency = (e) => {
        e.preventDefault();
        let emptyName = customAlaphabetValidation('Name', name);
        let emptyShortName = customAlaphabetValidationOptional('Short Name', shortName);
        let emptySymbol = emptyValidation('Symbol', symbol);
        emptyState();
        if (emptyName.isValid && emptyShortName.isValid && emptySymbol.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'currency',
                title: 'Currency',
                details: {
                    name: name,
                    shortName: shortName,
                    symbol: symbol
                }
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyShortName.errors) {
                setErrorShortName(emptyShortName.errors);
            }
            if (emptySymbol.errors) {
                setErrorSymbol(emptySymbol.errors);
            }
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            loadTasks();
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorName(error);
        }
    }, [createDetails, createError]);

    const handleAddMore = (e) => {
        createCurrency(e);
        setAddMore(true);

    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(search, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(search, sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.CURRENCY_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'currency',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Admin', 'link': '/admin' }, { 'label': 'Currency', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Currency'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Currency', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Currency', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('Currency'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Currency', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Currency', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={'#'}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Currency</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Currency', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>

                            <ListTable
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add Currency'}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createCurrency(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorName ? true : false}
                                    helperText={errorName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setName(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Short Name'
                                    variant={'standard'}
                                    className={clsx(classes.margin30t)}
                                    error={errorShortName ? true : false}
                                    helperText={errorShortName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setShortName(e.target.value)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label={["Symbol ", <span key={"Symbol"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    className={clsx(classes.margin30t)}
                                    error={errorSymbol ? true : false}
                                    helperText={errorSymbol}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setSymbol(e.target.value)}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                    >
                                        Save &amp; Close
                                    </Button>
                                    <Button
                                        key="add"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        onClick={(e) => handleAddMore(e)}
                                    >
                                        Add more
                                    </Button>
                                </Space>
                            </div>
                        </Box>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Currency'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={currencyDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}

export default Currency